/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Careers_Pay_Per_DayInputs */



/**
* | output |
* | --- |
* | "{amount} per day" |
*
* @param {Careers_Pay_Per_DayInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const careers_pay_per_day = /** @type {((inputs: Careers_Pay_Per_DayInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Pay_Per_DayInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`每天 ${i?.amount}`)
	return /** @type {LocalizedString} */ (`${i?.amount} per day`)
});